<template>
  <el-card style="max-height: 100px">
    <div class="flex_row_horizontally_vertical_center" >
      <el-avatar :size="40" :src="circleUrl" />
      <div class="flex_column" style="align-items: start;margin-left: 10px">
        <div style="font-size: 16px;line-height: 30px;">领导</div>
        <div style="font-size: 13px;line-height: 18px;max-width: 200px;text-align: start">领导领导领导领导领导领导领导领导领导领导领导领导领导领导</div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "AboutUserView"
}
</script>

<style scoped>

</style>